export const SET_ERROR = 'SET_ERROR'

export const ADD_COMMENT = 'ADD_COMMENT'
export const ADD_REACTION = 'ADD_REACTION'
export const CHANGE_LOCK_MODAL = 'CHANGE_LOCK_MODAL'
export const CHANGE_CONFIRM_CLOSING = 'CHANGE_CONFIRM_CLOSING'
// export const CHANGE_PROJECT_AVATAR = 'CHANGE_PROJECT_AVATAR'
export const CHANGE_PROJECT_NAME = 'CHANGE_PROJECT_NAME'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CLOSE_SYSTEM_DIALOG = 'CLOSE_SYSTEM_DIALOG'
export const COMMIT_PROJECT_REQUEST = 'COMMIT_PROJECT_REQUEST'
export const COMMIT_PROJECT_REQUEST_PURE = 'COMMIT_PROJECT_REQUEST_PURE'
export const CONNECT_FIGMA = 'CONNECT_FIGMA'
export const DELETE_BLOCK = 'DELETE_BLOCK'
export const DELETE_COMMENT = 'DELETE_COMMENT'
export const DELETE_PROJECT = 'DELETE_PROJECT'

export const DISCONNECT_FIGMA = 'DISCONNECT_FIGMA'
export const IMPORT_PROJECT = 'IMPORT_PROJECT'
export const RESET_AUTH = 'RESET_AUTH'
export const SET_AUTH = 'SET_AUTH'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
// export const MOVE_LINE_ITEM = 'MOVE_LINE_ITEM'
export const OPEN_BLOCK = 'OPEN_BLOCK'
export const OPEN_SYMBOL = 'OPEN_SYMBOL'
export const OPEN_MODAL = 'OPEN_MODAL'
export const OPEN_SYSTEM_DIALOG = 'OPEN_SYSTEM_DIALOG'
export const RESET_PROJECT = 'RESET_PROJECT'
export const SAVE_PROJECT_SUCCESS = 'SAVE_PROJECT_SUCCESS'
export const SETUP_SUCCESS = 'SETUP_SUCCESS'
export const SET_USER_EMOJIS = 'SET_USER_EMOJIS'

// Symbol library
export const MOVE_SYMBOL = 'MOVE_SYMBOL'

export const SHOW_COMMENTS = 'SHOW_COMMENTS'

export const UPDATE_COMMENT = 'UPDATE_COMMENT'
export const UPDATE_PROFILE = 'UPDATE_PROFILE'
export const UPDATE_PROJECT = 'UPDATE_PROJECT'
export const UPDATE_PROJECT_CUSTOM_AVATAR = 'UPDATE_PROJECT_CUSTOM_AVATAR'
export const UPDATE_PROJECT_PREVIEW = 'UPDATE_PROJECT_PREVIEW'
export const UPDATE_UI = 'UPDATE_UI'

export const SET_COMMENTS = 'MANAGER_SET_COMMENTS'

export const THREADS_PANEL_SET_SHOWN = 'THREADS_PANEL_SET_SHOWN'

export const SEO_PANEL_SET_SHOW = 'SEO_PANEL_SET_SHOW'

export const MESSAGE_VIEWED = 'MESSAGE_VIEWED'
export const SYNC_STATUS = 'SYNC_STATUS'

export const UI_SET_LOCKS = 'UI_SET_LOCKS'
export const UI_RELEASE_LOCKS = 'UI_RELEASE_LOCKS'
